import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";

export default function AdminMessages() {
  const [msgs, setMsgs] = useState([]);
  useEffect(() => { http.get("/admin/contact").then((r) => setMsgs(r.data)); }, []);
  return (
    <div data-testid="admin-messages-page">
      <div className="mb-8">
        <div className="text-[10px] tracking-[0.3em] uppercase text-pink-blush mb-2">Inbox</div>
        <h1 className="font-display text-4xl text-champagne">Your <span className="italic text-pink-hot">messages</span></h1>
      </div>
      {msgs.length === 0 ? (
        <div className="text-sm text-champagne/60 glass-panel p-8 rounded-md">No messages yet.</div>
      ) : (
        <div className="space-y-3">
          {msgs.map((m) => (
            <div key={m.id} className="glass-panel rounded-md p-5" data-testid={`message-${m.id}`}>
              <div className="flex justify-between items-start mb-2">
                <div className="font-display italic text-lg text-champagne">{m.name}</div>
                <div className="text-xs text-champagne/50">{new Date(m.created_at).toLocaleString()}</div>
              </div>
              <div className="text-xs text-rosegold mb-2">{m.email}</div>
              <p className="text-sm text-champagne/80 whitespace-pre-line">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
